import { mergeStyleSets, useTheme } from '@fluentui/react';

export const useStyles = (hasMenuItems: boolean = true) => {
  const theme = useTheme();

  return mergeStyleSets({
    providerButtonMenu: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    splitter: {
      height: '70%',
      borderLeft: hasMenuItems ? `1px ${theme.semanticColors.disabledBorder} solid` : 'none',
      visibility: hasMenuItems ? 'visible' : 'hidden',
    },
    splitButton: {
      width: '34px',
      height: '100%',
      visibility: hasMenuItems ? 'visible' : 'hidden',
      '&:hover': hasMenuItems
        ? {
            backgroundColor: theme.semanticColors.buttonBackgroundCheckedHovered,
          }
        : {},
    },
  });
};
